export default __webpack_public_path__ + "static/media/about_arcane_1.fb39d4de.jpg";